import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './index.module.less';
import MaterialListTable from './MaterialListTable';

interface MaterialTableProps {
  currentSelectNode: any;
  pageType: string;
  taskId?: string;
}

const MaterialTable: ForwardRefExoticComponent<PropsWithoutRef<MaterialTableProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    currentSelectNode,
    pageType,
    taskId,
  },
  ref,
) => {
  return (
    <>
      {currentSelectNode?.isMaterial ? (
        <MaterialListTable
          currentSelectNode={currentSelectNode}
          pageType={pageType}
          taskId={taskId}
        />
      ) : (
        null
      )}
    </>
  );
});

export default MaterialTable;
